var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H17.6V12H0V0Z",
    fill: "#00695C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.59961 2C6.53874 2 5.52133 2.42143 4.77118 3.17157C4.02104 3.92172 3.59961 4.93913 3.59961 6C3.59961 7.06087 4.02104 8.07828 4.77118 8.82843C5.52133 9.57857 6.53874 10 7.59961 10C8.66048 10 9.67789 9.57857 10.428 8.82843C11.1782 8.07828 11.5996 7.06087 11.5996 6C11.5996 4.93913 11.1782 3.92172 10.428 3.17157C9.67789 2.42143 8.66048 2 7.59961 2Z",
    fill: "#FF1744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default __webpack_public_path__ + "static/media/bd.8519f505697ac0bd8182c521c5554bd2.svg";
export { ForwardRef as ReactComponent };